// Single-source-of-truth for user-role display labels.
//
// NOTE: mapping restored to the ORIGINAL pre-TY-56 labels. The TY-56 swap
// (admin→"Admin", org_admin→"Fund Manager") hid the Module Access block in
// Create User because that block is gated on role === "org_admin", which
// users had always known as the "Admin" option. Reverted 2026-09-21.
// API and DB role values are unchanged — this file is display-only.
export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Fund Manager",
  org_admin: "Admin",
  investor: "Investor",
  prospective_client: "Prospective Client",
};

export const roleLabel = (role) => ROLE_LABEL[role] || role || "";
